import { Box, Flex, Text } from "@mantine/core"
import { ReactNode } from "react"
import classes from "../real.module.css"

export interface RankItem {
  key: string
  name: ReactNode
  /** Drives the bar length, relative to the largest row. */
  count: number
  /** Right-hand figure, already formatted with its unit. */
  value: ReactNode
}

// Ranked rows: number (top 3 dark), name, a thin bar, the figure on the right.
// Shared by «Топ 5 бараа» and the returns overview lists.
export function RankList({ items }: { items: RankItem[] }) {
  if (items.length === 0) {
    return (
      <Text fz={14} c="dimmed" ta="center" py="md">
        —
      </Text>
    )
  }

  const maxCount = Math.max(...items.map((i) => i.count), 1)
  return (
    <Box>
      {items.map((item, index) => (
        <Flex key={item.key} align="center" gap={10} className={classes.productItem}>
          <Box className={classes.productRank} data-top={index < 3 || undefined}>{index + 1}</Box>
          <Box style={{ flex: 1, minWidth: 0 }}>
            <Text className={classes.productName} lineClamp={1}>{item.name}</Text>
            <Box className={classes.productBar}>
              <Box className={classes.productBarFill} style={{ width: `${Math.max((item.count / maxCount) * 100, 6)}%` }} />
            </Box>
          </Box>
          <Text className={classes.productCount}>{item.value}</Text>
        </Flex>
      ))}
    </Box>
  )
}
